import type { PropsWithChildren } from 'react'
import { useIntl } from 'react-intl'

import HeadData from 'components/Common/HeadData'
import ModalProvider from 'contexts/ModalProvider'
import { DEFAULT_TRIP_IMAGE } from 'tripPlanner/config'

interface Props extends PropsWithChildren<{}> {}

function RootWrapper({ children }: Props) {
  const intl = useIntl()

  return (
    <ModalProvider>
      <HeadData
        title={intl.formatMessage({
          id: 'MAXLEEnndkp71h-tfxOx',
          defaultMessage: 'Trip Planner',
        })}
        description={intl.formatMessage({
          id: 's4adP7LVQlJdZcpOe6KX',
          defaultMessage: 'Easily plan your perfect trip, all in one place',
        })}
        imageUrl={DEFAULT_TRIP_IMAGE}
      />
      {children}
    </ModalProvider>
  )
}

export default RootWrapper
